export type BankSourceCreateResponse = {
  id: number
}
